import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _DISPLAY_MODEL_KEY_VS;

export var INTEGRATION_KEYS = {
  OUT_OF_STATE_TAX: 'outOfStateTax',
  REBATE_TAX_TYPES: 'enableRebateTaxType',
  CREDIT_BUREAU: 'creditBureau',
  CREDIT_BUREAU_OTHERS: 'otherCredit',
  SEVEN_HUNDRED_CREDIT: 'sevenHundredCredit',
  MULTIPLE_DOWNPAYMENTS: 'multipleDownPayments',
  CREDIT_APP_ROUTE_ONE: 'creditAppRouteOne',
  CREDIT_APP_CUDL: 'creditAppCudl',
  E_CONTRACT_ROUTE_ONE: 'econtractRouteOne',
  VIN_SOLUTIONS: 'vinSolutions',
  V_AUTO: 'vauto',
  DMVDESK: 'dmvDesk',
  VEHICLE_INVENTORY_UPDATE_SERVICE: 'vehicleInventoryUpdateService',
  VEHICLE_INVOICE_SERVICE: 'vehicleInvoiceService',
  OEM_STOCK_ID_GENERATION: 'oemStockIdGeneration',
  PEN: 'pen',
  ADD_BDC_USERS_IN_DEAL: 'bdcUserCommission',
  CERTIFICATE_REBATES: 'certificateRebates',
  ADD_KEYPER: 'keyper',
  ROUTE_ONE_SETUP: 'r1TradeInOwnershipType',
  VAUTO_RETAIL_PRICE: 'vautoRetailPrice',
  AUDIT: 'audit',
  CONCIERGE: 'concierge',
  RESIDUALIZE_ACCESSORIES: 'residualizeAccessories',
  OEM_UPDATE: 'updateOEM',
  CROSS_DEALERSHIP_INFORMATION: 'crossDealershipInformation',
  EXCLUDE_STOCK_SUB_TYPES: 'excludeStockSubTypes',
  EXCLUDE_STOCK_TYPES: 'excludeStockTypes',
  VW_CREDIT: 'creditAppVCI',
  AUDI_FINANCIAL_SERVICES: 'creditAudiFinancialServices',
  MERCEDES_FINANCIAL_SERVICES: 'creditAppMBFS',
  DEALER_TRACK: 'creditAppDealerTrack',
  E_CONTRACT_VCI: 'econtractVCI',
  E_CONTRACT_AUDI_FINANCIAL: 'econtractAudiFinancialServices',
  E_CONTRACT_MBFS: 'econtractMBFS',
  E_CONTRACT_BMWFS: 'econtractBMWFinancialServices',
  GM_VLS: 'gmVLS',
  OUT_BOUND_GLOBAL: 'outBoundGlobal',
  USED_VEHICLE_PROVIDER_DETAILS: 'usedVehicleProviderDetails',
  SINCRO_CONFIGS: 'sincroConfigs',
  VEHICLE_BUILDER_CONFIGS: 'vehicleBuilderConfigs',
  AUTO_POPULATE_FNI_MANAGER_DETAILS: 'autopopulateFnIManagerDetails',
  V_AUTO_APPRAISAL: 'vautoAppraisal',
  UPDATE_DEAL_TRADEIN_VALUES: 'updateDealTradeInValues',
  VALUATION_PROVIDER: 'valuationProvider',
  VEHICLE_VALUE: 'providersVehicleValue',
  CONSUMER_CREDIT_APPLICATION: 'consumerCreditApplication',
  NCC_CREDIT: 'nccCredit',
  FNI_EXPRESS: 'fnIExpress',
  VENDOR_SETUP_DETAILS: 'vendorSetupDetails',
  VEHICLE_HISTORY_AUTOCHECK: 'vehicleHistoryReportAutocheck',
  CONFIGURATIONS: 'configurations'
};
export var COMPLIANCE_KEYS = {
  BUREAU_PREFERENCE: 'bureauPreference',
  CREDIT_SCORE_DISCLOSURE_NOTICE: 'creditScoreDisclosureNotice',
  ADVERSE_ACTION_LETTER: 'adverseActionLetter',
  PRIVACY_NOTICE: 'privacyNotice',
  ADVERSE_ACTION_NOTICE: 'adverseActionNotice',
  EMAIL_NOTICES_AND_DISCLOSURES: 'enableSendEmail'
};
export var DISPLAY_MODEL = 'DISPLAY_MODEL';
export var BEST_STYLE_NAME = 'BEST_STYLE_NAME';
export var DISPLAY_MODEL_KEY_VS_VALUE = (_DISPLAY_MODEL_KEY_VS = {}, _defineProperty(_DISPLAY_MODEL_KEY_VS, DISPLAY_MODEL, 'displayModel'), _defineProperty(_DISPLAY_MODEL_KEY_VS, BEST_STYLE_NAME, 'bestStyleName'), _DISPLAY_MODEL_KEY_VS);